import { render, staticRenderFns } from "./IconChevron.vue?vue&type=template&id=04b1bcc0"
import script from "./IconChevron.vue?vue&type=script&lang=ts"
export * from "./IconChevron.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports